import type { VoidFunctionComponent } from 'react';

import COLORS from '../../../theme/colors';
import Flex from '../Flex';
import type { FOSSAColorName } from '../../../theme/colors';

type Props = {
  /**
   * Number between 0-100 (inclusive) to represent the percentage.
   */
  percent: number;
  /**
   * If the % value should be displayed.
   */
  showPercent?: boolean;
  /**
   * Color for the filled in portion of the percentage bar.
   */
  barColor?: FOSSAColorName;
};

/**
 * Displays a small "percentage" bar.
 */
const MiniPercentageBar: VoidFunctionComponent<Props> = ({
  percent,
  showPercent = true,
  barColor = 'fossaBlue',
}) => (
  <Flex justify="flex-start" align="center" gap={8}>
    <svg width="100" height="16" viewBox="0 0 100 16" data-testid="mini-percentage-bar-svg">
      {/* Background bar */}
      <rect x="0" y="4" width="100" height="8" rx="3" fill={COLORS.fossaGray10} />
      {/* Progress bar (50%) */}
      <rect x="0" y="4" width={percent} height="8" rx="3" fill={COLORS[barColor] || COLORS.fossaBlue} />
    </svg>
    {showPercent && (
      <span>
        {percent}%
      </span>
    )}
  </Flex>
);

export default MiniPercentageBar;
